import Swiper from 'swiper/bundle';

class UTHero {
  constructor() {
    this.wrapper = document.querySelector("[data-role='ut-hero']");

    if (!this.wrapper) return;

    this.swiperElm = this.wrapper.querySelector("[data-role='ut-hero-swiper']");
    this.swiperNext = this.wrapper.querySelector("[data-role='ut-hero-swiper-next']");
    this.swiperPrev = this.wrapper.querySelector("[data-role='ut-hero-swiper-prev']");

    if (!this.swiperElm || !this.swiperNext || !this.swiperPrev) return;

    this.swiper = new Swiper(this.swiperElm, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      // breakpoints: {
      //   768: {
      //     slidesPerView: 3,
      //     spaceBetween: 32,
      //   },
      // },
      // spaceBetween: 16,
      // loop: true,
      // autoplay: {
      //   delay: 2000,
      //   disableOnInteraction: false,
      // },
      // speed: 1500,
      // // breakpoints: {
      // //   768: {
      // //     slidesPerView: 3,
      // //     spaceBetween: 24,
      // //   },
      // // },
      navigation: {
        nextEl: this.swiperNext,
        prevEl: this.swiperPrev,
      },
    });
  }
}

export default UTHero;
